import React from 'react';
import { Icon } from '../core/Icon.jsx';

export function Input({
  size = 'md', invalid = false, mono = false, iconLeft, affixRight,
  className = '', ...rest
}) {
  const input = (
    <input
      className={[
        'sp-input', size !== 'md' && 'sp-input--' + size,
        invalid && 'sp-input--invalid', mono && 'sp-input--mono', className
      ].filter(Boolean).join(' ')}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  );
  if (!iconLeft && !affixRight) return input;
  return (
    <span className={['sp-inputwrap', iconLeft && 'sp-inputwrap--has-left', affixRight && 'sp-inputwrap--has-right'].filter(Boolean).join(' ')}>
      {iconLeft && <span className="sp-inputwrap__affix sp-inputwrap__affix--left"><Icon name={iconLeft} size={15} /></span>}
      {input}
      {affixRight && <span className="sp-inputwrap__affix sp-inputwrap__affix--right">{affixRight}</span>}
    </span>
  );
}
